/**
 * Ilkokul soru eslemesi (uretildi: runner POC questions*.json, 26 Eyl 2026).
 *
 * Canli exerciseCode "ecup_primary_{sinif}_1-{alanId}-{sira}" bicimindedir; alanId veritabanina gore
 * degisir (test ile canlida farkli). Bu yuzden soru, veritabanindan bagimsiz "sinif|alan|alan-ici sira"
 * anahtariyla PDF soru numarasina (pdfNo) eslenir; poc.css .q-s<no> / .q-g<N>-s<no> kurallari
 * canlida da uygulanir. Alan, item.subAreaName (Maarif alt beceri adi) uzerinden bulunur.
 */
export const SUBSKILL_TO_AREA: Record<string, string> = {
  "Sözcüğün Başlangıç Sesini Ayırt Etme": "Fonetik",
  "Sözcüğün Bitiş Sesini Ayırt Etme": "Fonetik",
  "Heceleri Birleştirme": "Fonetik",
  "Heceleri Fark Etme ve Ayırma": "Fonetik",
  "Sosyal-Duygusal Eğilim": "Sosyal-Duygusal",
  "Algoritmik Düşünme ve İşlem Basamaklarını Uygulama": "Matematik",
  "Matematiksel Muhakeme": "Matematik",
  "Matematiksel Problem Çözme": "Matematik",
  "Örüntüleri Belirleme ve Sınıflandırma": "Matematik",
  "Geometrik ve Uzamsal Muhakeme": "Matematik",
  "Görsel Özellikleri Ayırt Etme": "Dikkat",
  "Görsel-Uzamsal İlişkileri Çözümleme ve Zihinsel Döndürme": "Dikkat",
  "Görsel Dikkat ve Tarama": "Dikkat",
  "İşitsel Dikkat ve Yönerge Takibi": "Dikkat",
  "Sözel-İşitsel Çalışma Belleği": "Bellek",
  "Görsel Bilgiyi Hatırlama": "Bellek",
  "Görsel-Uzamsal Çalışma Belleği": "Bellek",
  "Kavramlar Arasında Anlamsal İlişki Kurma": "Dil",
  "Söz Varlığı ve Kavram Bilgisi": "Dil",
  "Sözel Yönergeleri Anlama ve Uygulama": "Dil",
  "Olayları Sıralama ve Anlatı Oluşturma": "Dil",
  "İşitsel Bilgiyi Hatırlama": "Bellek",
  "Sayı ve Nicelikleri Temsil Etme": "Matematik",
  "Aritmetik İşlemler ve İşlem İlişkileri": "Matematik",
  "Metinde Açıkça Verilen Bilgiyi Belirleme": "Okuma Anlama",
  "Sözcük Anlamını Bağlamdan Belirleme": "Okuma Anlama",
  "Metinden Hareketle Çıkarım Yapma": "Okuma Anlama",
  "Metnin Ana Fikrini ve Uygun Başlığını Belirleme": "Okuma Anlama",
  "Metindeki Olayları Oluş Sırasına Göre Düzenleme": "Okuma Anlama",
  "Sesleri Birleştirme ve Ses-Hece Yapısını Değiştirme": "Dil",
  "Sözlü İfade ve Anlam Oluşturma": "Dil",
  "Görsel Örüntüleri Çözümleme ve Muhakeme": "Dikkat",
  "Şekil-Zemin İlişkisini Ayırt Etme": "Dikkat"
};

export const PRIMARY_PDF_NO: Record<string, number> = {
  "1|Fonetik|1": 34,
  "1|Fonetik|2": 35,
  "1|Fonetik|3": 36,
  "1|Fonetik|4": 37,
  "1|Fonetik|5": 38,
  "1|Fonetik|6": 39,
  "1|Sosyal-Duygusal|1": 41,
  "1|Sosyal-Duygusal|2": 42,
  "1|Sosyal-Duygusal|3": 43,
  "1|Sosyal-Duygusal|4": 46,
  "1|Sosyal-Duygusal|5": 47,
  "1|Sosyal-Duygusal|6": 51,
  "1|Matematik|1": 3,
  "1|Matematik|2": 5,
  "1|Matematik|3": 6,
  "1|Matematik|4": 8,
  "1|Matematik|5": 9,
  "1|Dikkat|1": 13,
  "1|Dikkat|2": 16,
  "1|Dikkat|3": 15,
  "1|Dikkat|4": 17,
  "1|Dikkat|5": 14,
  "1|Bellek|1": 29,
  "1|Bellek|2": 26,
  "1|Bellek|3": 27,
  "1|Bellek|4": 28,
  "1|Dil|1": 19,
  "1|Dil|2": 21,
  "1|Dil|3": 22,
  "1|Dil|4": 23,
  "1|Bellek|5": 31,
  "1|Bellek|6": 32,
  "2|Matematik|1": 2,
  "2|Matematik|2": 3,
  "2|Matematik|3": 4,
  "2|Matematik|4": 5,
  "2|Matematik|5": 6,
  "2|Matematik|6": 7,
  "2|Matematik|7": 8,
  "2|Okuma Anlama|1": 10,
  "2|Okuma Anlama|2": 11,
  "2|Okuma Anlama|3": 12,
  "2|Okuma Anlama|4": 13,
  "2|Okuma Anlama|5": 14,
  "2|Okuma Anlama|6": 15,
  "2|Dikkat|1": 18,
  "2|Dikkat|2": 19,
  "2|Dikkat|3": 20,
  "2|Dikkat|4": 23,
  "2|Dikkat|5": 25,
  "2|Dikkat|6": 26,
  "2|Dil|1": 28,
  "2|Dil|2": 28,
  "2|Dil|3": 28,
  "2|Dil|4": 28,
  "2|Dil|5": 29,
  "2|Dil|6": 30,
  "2|Dil|7": 32,
  "2|Dil|8": 34,
  "2|Dil|9": 35,
  "2|Bellek|1": 37,
  "2|Bellek|2": 38,
  "2|Dikkat|7": 39,
  "2|Bellek|4": 40,
  "2|Bellek|5": 41,
  "2|Bellek|6": 42,
  "2|Sosyal-Duygusal|1": 44,
  "2|Sosyal-Duygusal|2": 45,
  "2|Sosyal-Duygusal|3": 46,
  "2|Sosyal-Duygusal|4": 47,
  "2|Sosyal-Duygusal|5": 48,
  "2|Sosyal-Duygusal|6": 49,
  "3|Matematik|1": 2,
  "3|Matematik|2": 4,
  "3|Matematik|3": 6,
  "3|Matematik|4": 7,
  "3|Matematik|5": 8,
  "3|Matematik|6": 9,
  "3|Okuma Anlama|1": 11,
  "3|Okuma Anlama|2": 12,
  "3|Okuma Anlama|3": 13,
  "3|Okuma Anlama|4": 14,
  "3|Okuma Anlama|5": 15,
  "3|Okuma Anlama|6": 16,
  "3|Dikkat|1": 19,
  "3|Dikkat|2": 20,
  "3|Dikkat|3": 21,
  "3|Dikkat|4": 22,
  "3|Dikkat|5": 23,
  "3|Dil|1": 25,
  "3|Dil|2": 25,
  "3|Dil|3": 25,
  "3|Dil|4": 25,
  "3|Dil|5": 25,
  "3|Dil|6": 26,
  "3|Dil|7": 28,
  "3|Dil|8": 29,
  "3|Dil|9": 30,
  "3|Bellek|1": 32,
  "3|Bellek|2": 33,
  "3|Bellek|3": 34,
  "3|Bellek|4": 36,
  "3|Bellek|5": 37,
  "3|Sosyal-Duygusal|1": 39,
  "3|Sosyal-Duygusal|2": 40,
  "3|Sosyal-Duygusal|3": 41,
  "3|Sosyal-Duygusal|4": 42,
  "3|Sosyal-Duygusal|5": 43,
  "3|Sosyal-Duygusal|6": 44,
  "3|Dikkat|6": 18,
  "3|Dil|10": 27,
  "3|Bellek|6": 35,
  "4|Matematik|1": 2,
  "4|Matematik|2": 3,
  "4|Matematik|3": 4,
  "4|Matematik|4": 5,
  "4|Matematik|5": 6,
  "4|Matematik|6": 7,
  "4|Okuma Anlama|1": 9,
  "4|Okuma Anlama|2": 10,
  "4|Okuma Anlama|3": 11,
  "4|Okuma Anlama|4": 12,
  "4|Okuma Anlama|5": 13,
  "4|Okuma Anlama|6": 14,
  "4|Dil|1": 24,
  "4|Dil|2": 25,
  "4|Dil|3": 26,
  "4|Okuma Anlama|7": 23,
  "4|Dil|5": 29,
  "4|Dil|6": 30,
  "4|Dikkat|1": 16,
  "4|Dikkat|2": 17,
  "4|Dikkat|3": 18,
  "4|Dikkat|4": 19,
  "4|Dikkat|5": 20,
  "4|Dikkat|6": 21,
  "4|Dikkat|7": 32,
  "4|Dikkat|8": 34,
  "4|Dikkat|9": 35,
  "4|Dikkat|10": 36,
  "4|Dikkat|11": 37,
  "4|Dikkat|12": 38,
  "4|Bellek|1": 50,
  "4|Bellek|2": 51,
  "4|Bellek|3": 52,
  "4|Bellek|4": 53,
  "4|Bellek|5": 54,
  "4|Bellek|6": 55,
  "4|Sosyal-Duygusal|1": 40,
  "4|Sosyal-Duygusal|2": 42,
  "4|Sosyal-Duygusal|3": 43,
  "4|Sosyal-Duygusal|4": 46,
  "4|Sosyal-Duygusal|5": 47,
  "4|Sosyal-Duygusal|6": 48
};
